import { omit } from 'lodash';
import { createSelector } from 'reselect';

import { getComponentSettings } from '../../selectors/settings-selectors';

export const getAppComponent = (state) => state.site.appComponent;

export const getOriginalAppComponent = (state) => state.site.originalAppComponent;

export const isPopup = (state) => state.site.isPopup;

// Widget is sometimes preloaded in other tabs in preview with the size of 0x0
export const isWidgetVisible = () => window.innerHeight > 0 && window.innerWidth > 0;

export const getFilters = (state) => state.site.filters;

export const getVisibileFilters = createSelector([getFilters, getComponentSettings], (filters, componentSettings) =>
  omit(filters, componentSettings.hiddenFilters),
);

export const getSorts = (state) => state.site.sorts;

export const isSocial = (state) => state.site.isSocial;

const isAppInstalled = (appName) => (state) => !!state.site.installedApps[appName];

export const isAllMembersInstalled = isAppInstalled('membersAllMembers');

export const isForumInstalled = isAppInstalled('wixForum');

export const isBlogInstalled = isAppInstalled('wixBlog');

export const getSiteLocale = (state) => state.site.siteLocale;

export const getMetaSiteId = (state) => state.site.metaSiteId;

export const isExperimentEnabled = (state, name) => {
  const experiment = state.experiments[name];
  return (experiment && experiment === 'true') || experiment === true;
};

export const getAllExperiments = (state) => {
  return state.experiments;
};

export const getIsMobile = (state) => state.site.isMobile;

export const getAppDefId = (state) => state.site.appDefId;

export const getViewMode = (state) => state.site.viewMode;

export const isDemoMode = (state) => state.site.isDemoMode;

export const isSocialChatInstalled = (state) => state.site.isSocialChatInstalled;

export const hasBadges = (state) => !!state.badgesDefinitions.ids && !!state.badgesDefinitions.ids.length;

export const getSignedInstance = (state) => state.site.signedInstance;

export const getIsRtlLocale = (state) => state.site.isRtlLocale;

export const getIsDemoMode = (state) => state.site.isDemoMode;
